/*global jQuery, google */
(function($) {



  'use strict';

  const $dropdown = $(".dropdown");
  const $dropdownToggle = $(".dropdown-toggle");
  const $dropdownMenu = $(".dropdown-menu");
  const showClass = "show";
   
  $(window).on("load resize", function() {

    $('[data-toggle="tooltip"]').tooltip()
    
    var h = $(window).height()-$('#header').height();
    
    $('.bg_banner').not('.first-bar').height(h+'px');
    if (this.matchMedia("(min-width: 768px)").matches) {
      $dropdown.hover(
        function() {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    } else {
      $dropdown.off("mouseenter mouseleave");
    }
  });
  
  $('.back-button').on('click', function() {
    history.go(-1);
  });


  $('.nav-link.dropdown-toggle').on('click', function() {
    document.location.href = $(this).attr('href');
  });

  $(function() {
    $('body').on('mouseenter', '.overlay', function() {
        $(this).addClass('shadow-lg').css('cursor', 'pointer'); 
      }
    );
    $('body').on('mouseleave', '.overlay', function() {
        $(this).removeClass('shadow-lg');
      }
    );


    $( "#word" ).on( "keydown", function(event) {
      if(event.which == 13) 
         $('.cerca').trigger('click');
    });

    $( "#word-home" ).on( "keydown", function(event) {
      if(event.which == 13) 
         $('.cerca-home').trigger('click');
    });

    $('body').on('click', '.cerca', function() {
      gtag('event', 'search', {
        'event_category': 'Ricerca',
        'event_label': $('#word').val()
      });
      document.location.href='/it/ricerca/' + $('#word').val();
    });

    $('body').on('click', '.cerca-home', function() {
      gtag('event', 'search', {
        'event_category': 'Ricerca',
        'event_label': $('#word-home').val()
      });
      document.location.href='/it/ricerca/' + $('#word-home').val();
    });

    $('body').on('change', '.select-tag', function() {
      document.location.href = $(this).find(':selected').data('href');
    });

    

    $('.actionTagEvent').on('click', function() {
        console.log('actionTagEvent');
        var label = $(this).data('label');
        var category =$(this).data('category');
        
        gtag('event', 'click', {
          'event_category': category,
          'event_label': label
        });

        
    });

    $('body').on('click', '.invia-contatto', function() {

      console.log('invia-contatto');

      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nominativo: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          telefono: {
            required: true
          },
          check_privacy: {
            required: true
          },
        },
        messages: {
          nominativo: {
            required: setup.texts.testi['inserire-nome']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.localita = $('#localita').val();
      arr.messaggio = $('#messaggio').val();

      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.id_pagina = $('#id_pagina').val();
      arr.pagina = $('#pagina').val();
      arr.id_negozio = $('#id_negozio').val();
      arr.negozio = $('#negozio').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nome').val('');
              $('#privacy').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');

              gtag('event', 'send-email', {
                'event_category': 'Contact',
                'event_label': 'compilazione form'
              });
              
            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };


  });

  


}(jQuery));


function goToElement(element) {
  $("html, body").animate({ scrollTop: $(element).offset().top }, 1000, function(){
    $(element + ' form .form-control' ).addClass('flash');
    $('#nome').focus().trigger('keydown.autocomplete');
    setTimeout(function(){$('.flash').removeClass('flash');}, 1000);

  });
}

